export { ExpectedSalary } from './ExpectedSalary';
export type { SalaryWithOptionalAmount } from './types';
